import Config from './Config.js';

export const tag = Config.VITE_CI_COMMIT_TAG;

export const commit = Config.VITE_CI_COMMIT_SHORT_SHA;

export const version = tag || commit || '0.0.0-dev';
